import Button from "@components/ui/button";
import Spinner from "@components/ui/spinner";
import { toast } from "react-toastify";

interface IProps {
  msg?: string;
  onCancel?: () => void;
}

export const sendMediaLibUploadingToast = ({
  msg = "Uploading...",
  onCancel,
}: IProps = {}) => {
  return toast.info(
    <div className="tw-flex tw-items-center">
      <Spinner className="tw-mr-2 tw-size-3 tw-border-primary-300" />
      {msg}
    </div>,
    {
      icon: false,
      autoClose: false,
      closeOnClick: false,
      className: "images-panel-clickable",
      closeButton: onCancel
        ? ({ closeToast }) => (
            <Button
              variant="secondary"
              size="xs"
              className="images-panel-clickable tw-my-auto tw-ml-4"
              onClick={(e) => {
                closeToast(e);
                onCancel();
              }}
            >
              Stop
            </Button>
          )
        : undefined,
    },
  );
};
